// React & Nextjs imports
import React from "react";
import Image from "next/image";

// Hooks & Utils
// import { setAnalyticsEvent } from "@/app/utils/SetAnalyticsEvent";

// Components
import ICMWrapper from "@/app/components/icm-wrapper";

// UI Components
// import { IconButton } from "@/stories/icon-button/icon-button";
// import { ButtonSize, ButtonVariant, RegularButton } from "@/stories/button/button";

// Icons
// import Bulb from "@/app/assets/icons/bulb";
import Feat1 from "@/app/assets/images/feat1.png";
import Feat2 from "@/app/assets/images/feat2.png";
import Feat3 from "@/app/assets/images/feat5.png";
import Feat4 from "@/app/assets/images/feat6.png";
import Feat5 from "@/app/assets/images/feat7.png";
import Feat6 from "@/app/assets/images/feat8.png";
import {
    generalProdctType,
    getRouteWiseProduct,
    productRoute,
    ProductRoute,
} from "@/types/product";
import { toTitleCase } from "@/app/utils/helper";
// import GlobalStocksWhyInvest from "@/app/assets/icons/global-stocks-why-invest";
// import ArrowRightWhite from "@/app/assets/icons/arrow-right-white";

interface WhyUsStocksProps {
    title: string;
    subtitle: string;
    icon: React.ReactNode;
}

interface Props {
    pageRoute: ProductRoute;
}

export default function WhyShouldEtfs({ pageRoute }: Props) {
    const GlobalInvesting: WhyUsStocksProps[] = [
        {
            title: "Market Index ETFs",
            subtitle: "Exposure to major US indices and broader market participation.",
            icon: (
                <div className="mb-7">
                    <Image src={Feat1} height={98} width={97} alt="" />
                </div>
            ),
        },
        {
            title: "Technology ETFs",
            subtitle: "Access innovation-led companies and sectors.",
            icon: (
                <div className="mb-7">
                    <Image src={Feat2} height={98} width={97} alt="" />
                </div>
            ),
        },
        {
            title: "Sector ETFs",
            subtitle:
                "Focused exposure to industries such as healthcare, energy, banking, and more.",
            icon: (
                <div className="mb-7">
                    <Image src={Feat3} height={98} width={97} alt="" />
                </div>
            ),
        },
        {
            title: "Dividend ETFs",
            subtitle: "ETFs focused on income-generating companies.",
            icon: (
                <div className="mb-7">
                    <Image src={Feat4} height={98} width={97} alt="" />
                </div>
            ),
        },
        {
            title: "Bond ETFs",
            subtitle: "Exposure to fixed income and debt-oriented global instruments.",
            icon: (
                <div className="mb-7">
                    <Image src={Feat5} height={98} width={97} alt="" />
                </div>
            ),
        },
        {
            title: "Commodity & Gold ETFs",
            subtitle: "Access alternative asset classes through ETFs.",
            icon: (
                <div className="mb-7">
                    <Image src={Feat6} height={98} width={97} alt="" />
                </div>
            ),
        },
    ];

    return (
        <div className="">
            <ICMWrapper>
                <div className="flex flex-col items-center py-s15 md:py-s20 md:pb-s17">
                    <h2 className="mb-14 max-w-[700px] text-center text-4xl font-semibold -tracking-[0.56px] md:mb-20 md:text-7xl md:leading-[67.2px] [&_br]:hidden md:[&_br]:block">
                        Why Should Indians Invest<br/>{" "}in US{" "}
                        {pageRoute === productRoute["us-stocks"]
                            ? toTitleCase(getRouteWiseProduct({ route: pageRoute! })) + "s"
                            : pageRoute === productRoute["us-etfs"] && generalProdctType.ETF}
                        ?
                    </h2>
                    <div className="mb-16 flex flex-col md:flex-wrap items-center justify-between gap-20 md:flex-row">
                        {GlobalInvesting.map((item, index) => (
                            <div
                                key={index}
                                className="flex md:w-1/4 flex-col items-center justify-center align-middle"
                            >
                                {item.icon}
                                <h3 className="mb-2 text-xl font-semibold leading-[26px]">
                                    {item.title}
                                </h3>
                                <p
                                    className="text-center text-sm font-regular leading-[22.4px] tracking-[0.6px]"
                                    dangerouslySetInnerHTML={{ __html: item.subtitle }}
                                ></p>
                            </div>
                        ))}
                    </div>

                    {/* <RegularButton
                        noIcon
                        showRightIcon={false}
                        size={ButtonSize.Large}
                        variant={ButtonVariant.SecondaryDefault}
                        className="w-full max-w-full border-neutralOpacityLight-30  hover:text-black md:max-w-fit"
                        label="Start Investing"
                        onClick={() => {
                            setAnalyticsEvent(
                                `${process.env.ICM_UE_URL || ""}/login`,
                                "US_Listing_Page_Start_Investing",
                            );
                            window.location.href = `${process.env.ICM_UE_URL || ""}/login`;
                        }}
                    /> */}
                </div>
            </ICMWrapper>
        </div>
    );
}
